export const API_GET_ALL_BY_DATE_LABAPPOINTMENT = "API_GET_ALL_BY_DATE_LABAPPOINTMENT";
export const API_GET_ALL_BY_DATE_LABAPPOINTMENT_SUCCESS = "API_GET_ALL_BY_DATE_LABAPPOINTMENT_SUCCESS";
export const API_GET_ALL_BY_DATE_LABAPPOINTMENT_FAIL = "API_GET_ALL_BY_DATE_LABAPPOINTMENT_FAIL";

export const API_GET_ALL_BETWEEN_DATES_LABAPPOINTMENT = "API_GET_ALL_BETWEEN_DATES_LABAPPOINTMENT";
export const API_GET_ALL_BETWEEN_DATES_LABAPPOINTMENT_SUCCESS = "API_GET_ALL_BETWEEN_DATES_LABAPPOINTMENT_SUCCESS";
export const API_GET_ALL_BETWEEN_DATES_LABAPPOINTMENT_FAIL = "API_GET_ALL_BETWEEN_DATES_LABAPPOINTMENT_FAIL";

export const API_POST_LABAPPOINTMENT = "API_POST_LABAPPOINTMENT";
export const API_POST_LABAPPOINTMENT_SUCCESS = "API_POST_LABAPPOINTMENT_SUCCESS";
export const API_POST_LABAPPOINTMENT_FAIL = "API_POST_LABAPPOINTMENT_FAIL";

export const API_PATCH_LABAPPOINTMENT = "API_PATCH_LABAPPOINTMENT";
export const API_PATCH_LABAPPOINTMENT_SUCCESS = "API_PATCH_LABAPPOINTMENT_SUCCESS";
export const API_PATCH_LABAPPOINTMENT_FAIL = "API_PATCH_LABAPPOINTMENT_FAIL";

export const API_DELETE_LABAPPOINTMENT = "API_DELETE_LABAPPOINTMENT";
export const API_DELETE_LABAPPOINTMENT_SUCCESS = "API_DELETE_LABAPPOINTMENT_SUCCESS";
export const API_DELETE_LABAPPOINTMENT_FAIL = "API_DELETE_LABAPPOINTMENT_FAIL";

export const API_GET_FOLDERS_PATIENT_FOR_LABAPPOINTMENT = "API_GET_FOLDERS_PATIENT_FOR_LABAPPOINTMENT";
export const API_GET_FOLDERS_PATIENT_FOR_LABAPPOINTMENT_SUCCESS = "API_GET_FOLDERS_PATIENT_FOR_LABAPPOINTMENT_SUCCESS";
export const API_GET_FOLDERS_PATIENT_FOR_LABAPPOINTMENT_FAIL = "API_GET_FOLDERS_PATIENT_FOR_LABAPPOINTMENT_FAIL";

export const RESET_LIST = "RESET_LIST";

export const API_GET_ALL_BY_DATE_LABAPPOINTMENT_BY_GROUP = "API_GET_ALL_BY_DATE_LABAPPOINTMENT_BY_GROUP";
export const API_GET_ALL_BY_DATE_LABAPPOINTMENT_BY_GROUP_SUCCESS = "API_GET_ALL_BY_DATE_LABAPPOINTMENT_BY_GROUP_SUCCESS";
export const API_GET_ALL_BY_DATE_LABAPPOINTMENT_BY_GROUP_FAIL = "API_GET_ALL_BY_DATE_LABAPPOINTMENT_BY_GROUP_FAIL";
